import React, { useState, useEffect } from 'react';

function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('gladdogs_cookie_consent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('gladdogs_cookie_consent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(28, 28, 28, 0.95)',
      color: '#fff',
      padding: '16px 24px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      zIndex: 9999,
      boxShadow: '0 -4px 12px rgba(0,0,0,0.1)',
      backdropFilter: 'blur(10px)',
      textAlign: 'center'
    }}>
      <div style={{ maxWidth: '800px', fontSize: '14px', lineHeight: '1.5' }}>
        Questo sito web utilizza i cookie per assicurarti la migliore esperienza di navigazione. 
        Continuando a navigare, accetti il nostro utilizzo dei cookie. 
        <br className="mobile-break" />
        <a href="#/privacy" style={{ color: 'var(--color-accent)', textDecoration: 'underline', marginLeft: '4px' }}>
          Leggi l'Informativa sulla Privacy
        </a>.
      </div>
      <button 
        onClick={acceptCookies}
        style={{
          backgroundColor: 'var(--color-primary)',
          color: '#fff',
          border: 'none',
          padding: '10px 24px',
          borderRadius: '30px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'background-color 0.3s'
        }}
        onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--color-primary-dark)'}
        onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--color-primary)'}
      >
        Accetta e chiudi
      </button>
      <style>{`
        @media (min-width: 768px) {
          .cookie-banner-container {
            flex-direction: row !important;
            justify-content: space-between !important;
            text-align: left !important;
          }
          .mobile-break {
            display: none;
          }
        }
      `}</style>
    </div>
  );
}

export default CookieBanner;
